import type { TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";
import { getListViewState } from "owa-mail-list-store";

// When an action or animation that was triggered via a hover icon or keyboard is completed, this mutator will be called to
// update the tableView's lastAutoFocusedRowKey to an empty string so that the previously focused mail list item
// can be forced to regain focus.
// This is necessary because the focus is on the mail list item that was just removed from the DOM.
// We should only do this if the previous mail list item that was focused is in the viewport.
// If it is not in the viewport, we should just keep focus on the list to prevent unexpected scrolls back up to that row.
const onActionOrAnimationCompletedMutator: (tableView: TableView) => void = mutatorAction("onActionOrAnimationCompletedMutator", (tableView: TableView): void => {
    const listViewState = getListViewState();
    const rowIndex = tableView.rowKeys.indexOf(tableView.lastAutoFocusedRowKey ?? "");
    if (rowIndex >= listViewState.startIndexVLV && rowIndex <= listViewState.endIndexVLV) {
        tableView.lastAutoFocusedRowKey = "";
    }
});
export default onActionOrAnimationCompletedMutator;
